module.exports = __webpack_public_path__ + "img/2005 (2).75e8e619.jpg";